/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdmissionFormDto } from '../models/AdmissionFormDto';
import type { AdmissionFormRequest } from '../models/AdmissionFormRequest';
import type { Page_AdmissionFormDto_ } from '../models/Page_AdmissionFormDto_';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdmissionFormControllerService {
  /**
   * getAdmissionForms
   * @returns Page_AdmissionFormDto_ OK
   * @throws ApiError
   */
  public static getAdmissionFormsUsingGet({
    limit,
    offset,
    search,
  }: {
    limit?: number;
    offset?: number;
    /**
     * search
     */
    search?: string;
  }): CancelablePromise<Page_AdmissionFormDto_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admission-forms',
      query: {
        limit: limit,
        offset: offset,
        search: search,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * createAdmissionForm
   * @returns AdmissionFormDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static createAdmissionFormUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: AdmissionFormRequest;
  }): CancelablePromise<AdmissionFormDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/admission-forms',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getInputTypes
   * @returns string OK
   * @throws ApiError
   */
  public static getInputTypesUsingGet(): CancelablePromise<
    Array<
      | 'CHECK_BOX'
      | 'DATE_PICKER'
      | 'DROPDOWN'
      | 'FILE_UPLOAD'
      | 'NUMBER_INPUT'
      | 'RADIO_BUTTON'
      | 'TEXTAREA'
      | 'TEXT_INPUT'
    >
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admission-forms/input-types',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getAdmissionForm
   * @returns AdmissionFormDto OK
   * @throws ApiError
   */
  public static getAdmissionFormUsingGet({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<AdmissionFormDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admission-forms/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateAdmissionForm
   * @returns AdmissionFormDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateAdmissionFormUsingPut({
    id,
    request,
  }: {
    /**
     * id
     */
    id: string;
    /**
     * request
     */
    request: AdmissionFormRequest;
  }): CancelablePromise<AdmissionFormDto | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/admission-forms/{id}',
      path: {
        id: id,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deleteAdmissionForm
   * @returns any OK
   * @throws ApiError
   */
  public static deleteAdmissionFormUsingDelete({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/admission-forms/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
